// src/lib/cnpjLookup.ts
//
// Normaliza a resposta da API de CNPJ da Focus NFe (mesmos nomes de campo já
// usados e validados em produção por src/pages/PessoasForm.tsx).

import { fiscalService } from '../services/fiscalService';

export interface DadosCnpj {
  razaoSocial: string;
  nomeFantasia: string;
  municipio: string;
  uf: string;
  codigoIbge: string;
  logradouro: string;
  numero: string;
  bairro: string;
  cep: string;
  email: string;
}

export async function buscarDadosCnpj(cnpjSujo: string): Promise<DadosCnpj | null> {
  const cnpj = cnpjSujo.replace(/\D/g, '');
  if (cnpj.length !== 14) {
    throw new Error('CNPJ inválido. Digite 14 números.');
  }

  const data = await fiscalService.consultarCnpjFocus(cnpj);
  // A resposta real da Focus NFe usa "razao_social" (não "nome") e o
  // endereço vem aninhado em "endereco.*", não solto na raiz do objeto -
  // com os nomes antigos, essa checagem nunca era verdadeira e a consulta
  // sempre "não encontrava" o CNPJ, mesmo quando a Focus respondia certo.
  if (!data || !data.razao_social) {
    return null;
  }
  const endereco = data.endereco || {};

  return {
    razaoSocial: data.razao_social || '',
    nomeFantasia: data.nome_fantasia || '',
    municipio: endereco.nome_municipio || '',
    uf: endereco.uf || '',
    codigoIbge: String(endereco.codigo_ibge ?? ''),
    logradouro: endereco.logradouro || '',
    numero: endereco.numero || '',
    bairro: endereco.bairro || '',
    cep: endereco.cep || '',
    email: data.email || '',
  };
}
